module.exports = __webpack_public_path__ + "media/images/scoreReport-265519d8c9494e4b1d2cb2c5166cc1e03fd5d5450b13f0f0cddfdf591f8a5e8a.svg";